// extracted by mini-css-extract-plugin
export default {"TeamsListContainer":"TeamsList_TeamsListContainer__XkpAS","ErrorText":"TeamsList_ErrorText__Lhph7"};